import React from "react";
import { useTheme } from "../context/ThemeContext";

const fmt = (n) =>
  n == null
    ? "—"
    : Number(n).toLocaleString();

function Delta({
  pct,
  isLoss = false,
}) {
  const { colors } = useTheme();

  if (pct == null) return null;

  const up = pct >= 0;

  const deltaColor = isLoss
    ? "#ff7b7b"
    : up
    ? "#ff7b7b"
    : "#22c55e";

  return (
    <div
      className="text-sm mt-2 flex items-center gap-1"
      style={{ color: deltaColor }}
    >
      <span>
        {up ? "▲" : "▼"}
      </span>

      <span>
        {Math.abs(pct).toFixed(1)}%
      </span>
    </div>
  );
}

function Card({
  label,
  value,
  unit,
  delta,
  dateLabel,
  isLoss = false,
}) {
  const { colors } = useTheme();

  return (
    <div
      className="rounded-xl p-4 min-h-[100px] border"
      style={{
        backgroundColor: colors.cardBg,
        borderColor: colors.border,
      }}
    >
      {/* LABEL */}
      <div
        className="text-[10px] uppercase tracking-wider mb-1"
        style={{ color: colors.textSecondary }}
      >
        {label}
      </div>

      {/* VALUE */}
      <div className="flex items-end gap-1">
        <div
          className="text-[18px] font-semibold leading-none"
          style={{
            color: isLoss ? "#ffb14a" : colors.primary,
          }}
        >
          {fmt(value)}
        </div>

        <div
          className="text-sm mb-1"
          style={{ color: colors.textSecondary }}
        >
          {unit}
        </div>
      </div>

      {/* DELTA */}
      {delta != null && (
        <Delta
          pct={delta}
          isLoss={isLoss}
        />
      )}

      {/* DATE */}
      {dateLabel && (
        <div
          className="text-sm mt-2"
          style={{ color: colors.textSecondary }}
        >
          {dateLabel}
        </div>
      )}
    </div>
  );
}

export default function KPIStrip({
  mode = "district",
  data = {},
}) {
 if (mode === "filtered") {
  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-4">
      <Card
        label="Total Flow"
        value={data.totalFlow?.value}
        unit="gal"
        delta={data.totalFlow?.deltaPct}
      />

      <Card
        label="Avg Daily"
        value={data.avgDaily?.value}
        unit="gal/d"
        delta={data.avgDaily?.deltaPct}
      />

      <Card
        label="Peak Day"
        value={data.peak?.value}
        unit="gal"
        dateLabel={data.peak?.dateLabel}
      />
    </div>
  );
}

  // DISTRICT MODE

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-5 gap-4 mt-4">

      <Card
        label="Supply"
        value={data.supply?.value}
        unit="gal"
        delta={
          data.supply?.deltaPct
        }
      />

      <Card
        label="Demand"
        value={data.demand?.value}
        unit="gal"
        delta={
          data.demand?.deltaPct
        }
      />

      <Card
        label="Loss"
        value={data.loss?.value}
        unit="gal"
        delta={
          data.loss?.deltaPct
        }
        isLoss
      />

      <Card
        label="Avg Daily"
        value={
          data.avgDaily?.value
        }
        unit="gal/d"
        delta={
          data.avgDaily?.deltaPct
        }
      />

      <Card
        label="Peak Day"
        value={data.peak?.value}
        unit="gal"
        dateLabel={
          data.peak?.dateLabel
        }
      />
    </div>
  );
}